<template>
  <section class="octobus__section" v-if="departure && arrived && price">
    <div :class="{ 'octobus__container': !isFullWidth }">
      <h1 class="octobus__subtitle is-hidden-touch">
        {{$t('title.title')}}
      </h1>
      <h2 class="octobus__title">
        <div class="is-size-5-touch octobus__columns is-mobile is-vcentered">
          <div class="octobus__column is-narrow">
            <span class="departure is-block-touch">{{departure}}</span>
            <span class="is-hidden-touch">-</span>
            <span class="arrived is-block-touch">{{arrived}}</span>
          </div>
            <div class="octobus__column has-text-right-touch">
              <span class="octobus__price">{{$t('title.prefixData')}} {{ when | data }}</span>
            </div>
        </div>
      </h2>
    </div>
  </section>
</template>

<script>
import moment from 'moment';

export default {
  name: 'Title',
  props: {
    departure: {
      type: String,
      default() {
        return '';
      },
    },
    arrived: {
      type: String,
      default() {
        return '';
      },
    },
    price: {
      type: [String, Number],
      default() {
        return '';
      },
    },
    when: {
      type: Date,
    },
  },
  filters: {
    data(value) {
      return moment(value).format('DD.MM.YYYY');
    },
  },
  computed: {
    isFullWidth() {
      return this.$fullwidth;
    },
    currencySymbol() {
      const name = this.$root.octobusCurrency ? this.$root.octobusCurrency.name : '';
      const currency = name || this.$root.octobusCurrencyObj;

      return typeof currency === 'object' ? currency.name : currency;
    },
  },
};
</script>

<style lang="scss">
/* Small Devices, Tablets */
@media only screen and (max-width : 768px) {

}

</style>



// WEBPACK FOOTER //
// src/components/_common/Title.vue